var map = {
	"./01_get_contracts.json": "Fui1",
	"./02_get_premiumIndex.json": "5uda",
	"./03_get_openInterest.json": "ewcP",
	"./04_get_kline.json": "FuQd",
	"./05_get_depth.json": "GbOE",
	"./06_get_ticker.json": "6xac"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "J1Pj";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/api/market \.json$
// module id = J1Pj
// module chunks = 3